<template>
    <div class="main-body">
        <el-page-header @back="goBack" :content="campaign_name"></el-page-header>
        <h4>Summary</h4>
        <div class="summary">
            <el-row :gutter="16">
                <el-col :span="8">
                    <el-card shadow="never" v-loading="loadingSummary">
                        <span class="font-32">{{ this.summaryData.queue_count }}</span>&nbsp;
                        <span class="font-12 vertical-top">Queue</span>
                    </el-card>
                </el-col>
                <el-col :span="8">
                    <el-card shadow="never" v-loading="loadingSummary">
                        <span class="font-32 text-success">{{ this.summaryData.success_count }}</span>&nbsp;
                        <span class="font-12 vertical-top">Success</span>
                    </el-card>
                </el-col>
                <el-col :span="8">
                    <el-card shadow="never" v-loading="loadingSummary">
                        <span class="font-32 text-warning">{{ this.summaryData.fail_count }}</span>&nbsp;
                        <span class="font-12 vertical-top">Fail</span>
                    </el-card>
                </el-col>
            </el-row>
        </div>
        <h4>Detail</h4>
        <div class="detail">
            <el-table v-loading="tableLoading" :data="tableData" border>
                <el-table-column type="expand" label="∷">
                    <template slot-scope="scope">
                        <ul>
                            <li>{{ $strings('word/message_id') }}: {{ scope.row.message_id }}</li>
                            <li>{{ $strings('word/cp_app_id') }}: {{ scope.row.cp_app_id }}</li>
                        </ul>
                    </template>
                </el-table-column>
                <el-table-column :label="$strings('word/cp_app_id')">
                    <template slot-scope="scope">{{ mapping.apps[scope.row.cp_app_id] }}</template>
                </el-table-column>
                <el-table-column prop="msisdn" :label="$strings('word/msisdn')" width="120"></el-table-column>
                <el-table-column prop="country" :label="$strings('word/country')" width="140">
                    <template slot-scope="scope">
                        <span>{{ countryName(scope.row.country) }} ({{ scope.row.country }})</span>
                    </template>
                </el-table-column>
                <el-table-column prop="amount" :label="$strings('word/amount')"></el-table-column>
                <el-table-column prop="status_code" :label="$strings('word/status_code')">
                    <template slot-scope="scope">{{ $strings('word/trx_status/' + scope.row.status_code) }}</template>
                </el-table-column>
                <el-table-column prop="is_flash" :label="$strings('word/is_flash')">
                    <template slot-scope="scope">{{ scope.row.is_flash > 0 ? 'Y' : 'N' }}</template>
                </el-table-column>
                <el-table-column prop="is_unicode" :label="$strings('word/is_unicode')">
                    <template slot-scope="scope">{{ scope.row.is_unicode > 0 ? 'Y' : 'N' }}</template>
                </el-table-column>
                <el-table-column prop="ct_time" :label="$strings('word/ct_time')" width="160">
                    <template slot-scope="scope">
                        {{ convertUnixToDate(scope.row.ct_time) }}
                    </template>
                </el-table-column>
                <el-table-column prop="up_time" :label="$strings('word/up_time')" width="160">
                    <template slot-scope="scope">
                        {{ convertUnixToDate(scope.row.up_time) }}
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination" v-if="pagination.total > pagination.size" style="text-align: right">
            <el-pagination background layout="prev, pager, next" :total="pagination.total"
                           :page-size.sync="pagination.size"
                           :current-page.sync="pagination.page" @current-change="changePage"></el-pagination>
        </div>
    </div>
</template>

<script>
import {EVENT_ROUTER_BACK, PubSubGlobal} from "../../../../../utils/pubsub";
import {CpSitAppRead, CpSiteDashSummaryRead, CpSiteTrxRead} from "../../../../../api/cpsite/api";
import {GetItem} from "../../../../../utils/storage";
import {CTS, STORAGE_KEY_LOGIN_TZ} from "../../../../../config/config";
import {UnixToDateFull} from "../../../../../utils/time";
import FlagByCountryCode from "../../../../../utils/flag";

export default {
    props: ['campaign_id', 'campaign_name'],
    name: "cpsite-send-report-detail",
    data() {
        return {
            tableData: [],
            tableLoading: true,
            loadingSummary: true,
            summaryData: {'success_count': 0, 'fail_count': 0, 'queue_count': 0},
            trxInput: {
                tz: GetItem(STORAGE_KEY_LOGIN_TZ) * 1,
                campaign_id: this.campaign_id,
            },
            pagination: {total: 0, page: 1, size: 20},
            mapping: {apps: {}},
            options: {cts: CTS}
        }
    },
    created() {
        this.fetchSummary();
        this.fetchDetail();
        this.prepare();
    },
    methods: {
        countryName(ct) {
            let country = '/';
            this.options.cts.forEach((item) => {
                if (item.value === ct) {
                    country = FlagByCountryCode(item.value) + " " + item.label + " ";
                }
            })
            return country;
        },
        prepare() {
            CpSitAppRead({page: 1, size: 1000}).then((resp) => {
                this.mapping.apps = {};
                resp.data.data.rows.forEach((item) => {
                    this.mapping.apps[item.app_id] = item.app_name;
                })
            });
        },
        convertUnixToDate(ts) {
            let tz = parseInt(GetItem(STORAGE_KEY_LOGIN_TZ))
            return UnixToDateFull(ts, tz);
        },
        changePage() {
            this.fetchTableData();
        },
        goBack() {
            this.$router.push('/cpsite/send-report');
            PubSubGlobal.publish(EVENT_ROUTER_BACK, "/cpsite/send-report")
        },
        fetchDetail() {
            this.tableLoading = true;
            this.trxInput.page = this.pagination.page;
            this.trxInput.size = this.pagination.size;
            CpSiteTrxRead(this.trxInput).then((resp) => {
                if (resp.data.data.count > 0) {
                    this.tableData = resp.data.data.rows;
                } else {
                    this.tableData = [];
                }
            }).finally(() => {
                this.tableLoading = false;
            });
        },
        fetchSummary() {
            this.loadingSummary = true;
            CpSiteDashSummaryRead(this.trxInput).then((resp => {
                if (resp.data) {
                    this.summaryData = resp.data.data;
                }
            })).finally(() => {
                this.loadingSummary = false;
            });
        }
    }
}
</script>

<style scoped lang="scss">
.summary {
    margin: 1em 0;
}
</style>